var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.763 13.237 10 19.475 20.237 9.237l-2.474-2.474L10 14.525l-3.763-3.762-2.474 2.474Z"}));
}

Tick.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 24 24"};

module.exports = Tick;

Tick.default = Tick;
